module.exports = __webpack_public_path__ + "img/20200515_162918.a92584a7.jpg";